import React from 'react'
import { selectVdeGeoentityMarkers } from '../../../store/geoentity/geoentity.selectors'
import PoisMarkers from './PoisMarkers'

const VdeMarkers = () => <PoisMarkers selectMarkers={selectVdeGeoentityMarkers} />

export default VdeMarkers
